import type { ItemType } from 'app/common/ui-next/plain-selector'

export enum VendingMachineKind {
  Snack = 'snack',
  Coffee = 'coffee',
}

export const defaultVendingMachineKind = VendingMachineKind.Snack

export const vendingMachineKindItems: Array<ItemType> = [
  {
    id: VendingMachineKind.Snack,
    title: 'Снэковый',
  },
  {
    id: VendingMachineKind.Coffee,
    title: 'Кофейный',
  },
]

export const getVendingMachineKind = (
  value?: string | null,
): VendingMachineKind => {
  const normalizedValue = String(value || '').trim().toLowerCase()

  if (normalizedValue === VendingMachineKind.Coffee) {
    return VendingMachineKind.Coffee
  }

  return VendingMachineKind.Snack
}
